
	import { Observer } from 'mobx-vue';
	import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';

	@Observer
	export default class IQubeSVGWithFoot extends Vue {}
